import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import Assets from "../../../core/Assets";
import service from "../../services";
import SuccessErrorDialog from "../../components/SuccessErrorDialog";
import FullScreenUploadDialog from "../../components/FullScreenUploadDialog";
import SeparateFileUploader, {
  ChildMethods,
  FileStatus,
} from "../../components/SeparateFileUploader";

const Header: React.FC = () => (
  <header className="navbar navbar-expand-lg navbar-custom">
    <div className="container-fluid">
      <a className="navbar-brand" href="https://mffire.com">
        <img src={Assets.logoBlack} alt="Logo" />
      </a>
      <div className="navbar-text ms-auto">
        <a
          style={{ color: "white" }}
          href="https://mffire.com"
          className="visit-btn"
        >
          Visit Website
        </a>
      </div>
    </div>
  </header>
);

const HeaderImage: React.FC = () => {
  return (
    <section
      className="container-fluid my-0 d-flex align-items-end"
      id="header-image"
      style={{
        backgroundImage: `url('https://mffire.com/app/uploads/2016/04/banner-testimonials.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="overlay"></div>
      <div className="container pb-4 text-start">
        <h1 className="text-white">
          Your Stove, Our Innovation: Share & Contribute
        </h1>
      </div>
    </section>
  );
};

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="container-fluid">
      <div className="row m-0 align-items-end mb-5">
        <div className="col-12 col-md-4 text-center text-md-start">
          <img
            alt="Logo Image"
            data-src="https://mffire.com/app/themes/mffire/dist/img/logo-white.svg"
            className="lazy img-fluid footer-logo loaded"
            src="https://mffire.com/app/themes/mffire/dist/img/logo-white.svg"
            data-loaded="true"
          />
        </div>
      </div>

      <div className="row m-0 align-items-end">
        <div className="col-12 col-md-4 order-3 order-md-1 text-center text-md-start">
          <p id="copyright">© 2025 MF Fire, Inc. All rights reserved.</p>
        </div>

        <div className="col-12 col-md-4 order-1 order-md-2 d-flex justify-content-center">
          <ul
            id="menu-footer-navigation"
            className="list-inline d-flex"
            style={{ gap: "12px" }}
          >
            <li className="nav-item menu-item menu-item-type-custom menu-item-object-custom menu-item-3200">
              <a
                title="1-855-MFFire1"
                data-id="1-855-mffire1"
                href="tel:1-855-MFFire1"
                className="1-855-mffire1 nav-link"
              >
                1-855-MFFire1
              </a>
            </li>
            <li
              id="menu-item-36"
              className="nav-item menu-item menu-item-type-post_type menu-item-object-page menu-item-36"
            >
              <a
                title="MF Fire Privacy Policy"
                data-id="mffireprivacypolicy"
                href="https://mffire.com/privacy-policy/"
                className="mffireprivacypolicy nav-link"
              >
                MF Fire Privacy Policy
              </a>
            </li>
            <li
              id="menu-item-37"
              className="nav-item menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-12 current_page_item menu-item-37 active"
            >
              <a
                title="Contact MF Fire"
                data-id="contactmffire"
                href="https://mffire.com/contact/"
                className="contactmffire nav-link"
              >
                Contact MF Fire
              </a>
            </li>
          </ul>
        </div>

        <div className="col-12 col-md-4 order-2 order-md-3 d-flex justify-content-center justify-content-md-end">
          <ul
            className="list-inline d-flex justify-content-between w-50"
            id="social"
          >
            <li>
              <a href="https://www.facebook.com/MFFire">
                <img src="./assets/facebook.svg" width="16px" height="16px" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/_MFFire">
                <img src="./assets/twitter.svg" width="16px" height="16px" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/mf_fire/">
                <img src="./assets/instagram.svg" width="16px" height="16px" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/mf-fire-benefit-llc/">
                <img src="./assets/linkedin.svg" width="16px" height="16px" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

const Details: React.FC = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  return (
    <>
      <section className="container my-5">
        <div className="row align-items-start">
          <div className="col-12 col-md-6 order-first order-md-last">
            {!isVideoLoaded && (
              <img
                src={Assets.demoVideoPreview}
                alt="Left"
                className="img-fluid rounded"
              />
            )}
            <video
              style={{ visibility: isVideoLoaded ? "visible" : "hidden" }}
              className="img-fluid rounded object-cover"
              loop
              controls
              playsInline
              autoPlay
              muted
              onLoadedData={() => setIsVideoLoaded(true)}
            >
              <source src={Assets.demoVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="col-12 col-md-6 text-right order-last order-md-first mt-4 mt-md-0">
            <h2 className="text-primary mb-4">
              Calling all wood stove owners!
            </h2>
            <p>
              MF Fire is about to unveil new wood stove technology called Fire
              MAPS to help owners get the most out of their stoves{" "}
              <b>
                <u>and we need your help!</u>
              </b>{" "}
              After testing in consumer homes for the past few years, we are
              getting ready to enter the market. The last big step is teaching
              Fire MAPS to work with any brand and model of wood stove
            </p>
            <p>
              To help us do that, please record 30-60 second videos on your
              phone interacting with your stove, including opening and closing
              the door &#40;during start up or reload&#41;, but also any other
              adjustments you make like air controls. It helps to have one
              person record while another is opening and closing the door.{" "}
              <b>Watch the 1-minute video on this page to see what we need.</b>
            </p>

            <p>
              Have fun with it! Grab a friend to help. Try different camera
              angles, room lighting, and distances &#40;5-15 feet is ideal&#41;.
              Your stove can be idle or in use &#40;safety first!&#41; You can
              walk in and out of the picture, the dog can be lying there --- it
              is all good! But please have the person recording the video remain
              in one location for each video.
            </p>

            <p>
              Feel free to record and upload more than one video – more is
              better to help stress test the product.{" "}
              <b>
                Upload 3 or more unique videos and we’ll send you free wood
                stove gloves! &#40;$34.95 value&#41;{" "}
              </b>
              &#40;*Limited to the first 100 sets of videos. Everyone is
              encouraged to submit videos, but free gloves are only available
              for US shipping&#41;
            </p>

            <p>
              Your privacy and data security are important to us. You can remain
              anonymous. Simply upload your videos - no personal information is
              needed. Or let us know how to send you free wood gloves as our way
              to say thank you for your help.
            </p>

            <p>
              Click{" "}
              <b>
                <a className="c-link text-primary" href="#section-contact">
                  here
                </a>
              </b>{" "}
              to see our privacy policy. If you have any questions, please email
              us at{" "}
              <a
                className="c-link text-primary"
                href="mailto:support@mffire.com"
              >
                support@mffire.com
              </a>
            </p>

            <p>
              <b>
                <i>What is Fire MAPS? </i>
              </b>
              Fire MAPS is a patented wood stove accessory that works with major
              wood stove brands, new and old, to improve efficiency, lower
              emissions, and save you money. It provides real-time fire
              monitoring, live and historical fire and usage data, and guidance
              to learn how to use or get the most out of your stove. See fire
              temperatures, ideal reloading times, earn expert badges, receive
              real-time alerts and safety information, access your fire history
              and performance, see seasonal savings from increased performance,
              and much more.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

const Contact: React.FC = () => (
  <>
    <section id="section-contact" className="container my-5">
      <div className="row align-items-center">
        <div className="col-12 col-md-12 text-right order-last order-md-first mt-4 mt-md-0">
          <h2 className="text-primary mb-4">Privacy Policy</h2>
          <p>
            At MF Fire, your privacy and data security are our top priorities.
            The images and videos you upload on this page will be used
            exclusively for training and development purposes to enhance the
            accuracy and performance of our FireMaps system.
          </p>
          <p>
            This is a secure and trusted web page created by MFFire. Your data
            will remain confidential and will not be shared with any third
            parties or used for purposes beyond improving our system.
          </p>
          <p>
            If you have any concerns or questions, please don't hesitate to
            contact us at{" "}
            <a className="c-link text-primary" href="mailto:support@mffire.com">
              support@mffire.com
            </a>
          </p>
        </div>
      </div>
    </section>
  </>
);

const FormComponent: React.FC = () => {
  const fileUploadRef = useRef<ChildMethods>(null);

  // Response Dialogs
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogInfo, setDialogInfo] = useState({
    title: "",
    message: "",
    type: "success" as "success" | "error" | "input",
  });

  // Progress Dialog
  const [isUploading, setUploading] = useState(false);

  // Upload error msg
  const [isSubmitClicked, setSubmitClicked] = useState(false);
  const [isFileUploadingCompleted, setFileUploadingCompleted] = useState(false);

  const [formData, setFormData] = useState({
    stoveName: "",
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    files: null as FileList | null,
  });

  const [errors, setErrors] = useState({
    stoveName: "",
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
  });

  const validateInput = (id: string, value: string) => {
    if (value === "") return "";
    switch (id) {
      case "stoveName":
        return /^.{1,50}$/.test(value)
          ? ""
          : "Invalid input (max. 50 characters allowed)";
      case "firstName":
      case "lastName":
        return /^[a-zA-Z]{1,20}$/.test(value)
          ? ""
          : "Invalid input (max. 20 alphabetic characters allowed)";
      case "email":
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,60}$/.test(value)
          ? ""
          : "Invalid input (max. 60 characters allowed)";
      case "contact":
        return value === "" || /^[0-9]{10}$/.test(value)
          ? ""
          : "Please enter your 10 digit phone number";

      default:
        return "";
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [id]: files }));
    } else {
      const errorMessage = validateInput(id, value);
      setErrors((prev) => ({ ...prev, [id]: errorMessage }));
      setFormData((prev) => ({ ...prev, [id]: value }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (Object.values(errors).find((x) => x.length !== 0)) {
      return;
    }

    setSubmitClicked(true);
    if (!isFileUploadingCompleted) {
      return;
    }

    if (fileUploadRef.current) {
      let userUploadedFiles: FileStatus[] = [];
      userUploadedFiles = fileUploadRef.current.fetchFiles();

      // Check files
      if (userUploadedFiles.length === 0) {
        setDialogInfo({
          title: "Invalid",
          message: "Please select files.",
          type: "error",
        });
        setDialogOpen(true);
        return;
      }

      // Uploading files
      const uploading = userUploadedFiles.filter(
        (x) => x.status === "uploading"
      );
      if (uploading.length > 0) {
        setDialogInfo({
          title: "Uploading",
          message: "Some files still uploading, still want to continue?",
          type: "input",
        });
        setDialogOpen(true);
        return;
      }

      // Failed files
      const failed = userUploadedFiles.filter(
        (x) => x.status === "failed" || x.status === "out_of_size"
      );
      if (failed.length > 0) {
        setDialogInfo({
          title: "Uploading",
          message: "Some files have erros, still want to continue?",
          type: "input",
        });
        setDialogOpen(true);
        return;
      }

      // push data
      pushUserData();
    }
  };

  const pushUserData = async () => {
    try {
      setUploading(true);
      let userUploadedFiles: FileStatus[] = [];

      if (fileUploadRef.current) {
        userUploadedFiles = fileUploadRef.current.fetchFiles();
      }
      const uploadedFiles = userUploadedFiles.filter(
        (x) => x.status === "completed"
      );
      const files = uploadedFiles.map((x) => x.uploadKey);

      await service.userService.pushUserDetails({
        StoveName: formData.stoveName,
        FirstName: formData.firstName,
        LastName: formData.lastName,
        Email: formData.email,
        Contact: formData.contact,
        files: files,
      });

      setDialogInfo({
        title: "Success",
        message: "Data submitted successfully!",
        type: "success",
      });
      setDialogOpen(true);
    } catch (e) {
      setDialogInfo({
        title: "Error",
        message: "Something went wrong, please try again.",
        type: "error",
      });
      setDialogOpen(true);
    } finally {
      setUploading(false);
    }
  };

  const onDialogClose = () => {
    setDialogOpen(false);
    if (dialogInfo.type === "success") {
      window.location.reload();
    }
  };

  const handleUploadFileStatus = (status: boolean) => {
    setFileUploadingCompleted(status);
  };

  return (
    <>
      <section className="container bg-light py-5 my-5 rounded">
        <h2 className="text-center text-primary mb-4">
          Submit Your Information
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="stoveName" className="form-label">
              <b>Stove Make and Model</b> &#40;Optional&#41;
            </label>
            <input
              type="text"
              className="form-control"
              id="stoveName"
              onChange={handleChange}
            />
            {errors.stoveName && (
              <small className="text-danger">{errors.stoveName}</small>
            )}
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="firstName" className="form-label">
                <b>First Name</b> &#40;Optional&#41;
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                onChange={handleChange}
              />
              {errors.firstName && (
                <small className="text-danger">{errors.firstName}</small>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="lastName" className="form-label">
                <b>Last Name</b> &#40;Optional&#41;
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                onChange={handleChange}
              />
              {errors.lastName && (
                <small className="text-danger">{errors.lastName}</small>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="email" className="form-label">
                <b>Email</b> &#40;Optional&#41;
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                onChange={handleChange}
              />
              {errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="contact" className="form-label">
                <b>Phone #, 10 #'s only</b> &#40;Optional&#41;
              </label>
              <input
                type="tel"
                className="form-control"
                id="contact"
                onChange={handleChange}
              />
              {errors.contact && (
                <small className="text-danger">{errors.contact}</small>
              )}
            </div>
          </div>
          <SeparateFileUploader
            ref={fileUploadRef}
            uploadStatusCallback={(status) => handleUploadFileStatus(status)}
          />
          <div className="mt-3">
            {!isFileUploadingCompleted && isSubmitClicked && (
              <small className="text-danger">
                Some files are still uploading. Please wait...
              </small>
            )}
          </div>
          <div className="d-flex mt-3 justify-content-start">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </section>
      <SuccessErrorDialog
        open={dialogOpen}
        onClose={onDialogClose}
        title={dialogInfo.title}
        message={dialogInfo.message}
        type={dialogInfo.type}
        noButton={{
          label: "NO",
          onClick: () => {
            setDialogOpen(false);
          },
        }}
        yesButton={{
          label: "YES",
          onClick: () => {
            setDialogOpen(false);
            pushUserData();
          },
        }}
      />
      <FullScreenUploadDialog open={isUploading} onClose={() => {}} />
    </>
  );
};

const App: React.FC = () => {
  return (
    <div>
      <Header />
      <HeaderImage />
      <Details />
      <FormComponent />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
